import "../../../assets/css/font.css.ts.vanilla.mjs";
import "./ReoLink.css.ts.vanilla.mjs";
var o = "var(--p273__linkTemplate-1f0b_fc58d3ec2__defaultColor__1oj8qts1q)", a = "var(--p273__linkTemplate-1f0b_fc58d3ec2__defaultHoverColor__1oj8qts1r)", n = "var(--p273__linkTemplate-1f0b_fc58d3ec2__disableColor__1oj8qts17)", r = "p273__ReoLink-0908_b6ea279__y9soa13", i = { underline: "p273__ReoLink-0908_b6ea279__underline__y9soa14", hoverUnderline: "p273__ReoLink-0908_b6ea279__hoverUnderline__y9soa15", none: "p273__ReoLink-0908_b6ea279__none__y9soa16" }, l = "p273__ReoLink-0908_b6ea279__y9soa17", p = "p273__ReoLink-0908_b6ea279__y9soa1c", k = "p273__ReoLink-0908_b6ea279__y9soa1b", s = "p273__ReoLink-0908_b6ea279__y9soa1a", L = "p273__ReoLink-0908_b6ea279__y9soa18", b = { large: "p273__ReoLink-0908_b6ea279__y9soa10", medium: "p273__ReoLink-0908_b6ea279__y9soa11", small: "p273__ReoLink-0908_b6ea279__y9soa12" };
export {
  o as defaultColor,
  a as defaultHoverColor,
  n as disabledColor,
  r as reoLink,
  i as reoLinkAnimate,
  l as reoLinkContent,
  p as reoLinkIcon,
  k as reoLinkIconAnimate,
  s as reoLinkIconGroup,
  L as reoLinkIconWrap,
  b as sizeMap
};
//# sourceMappingURL=ReoLink.mjs.map
